import { ImportTypes } from "@taabl/common-lib/constants/ImportTypes";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Button, Card, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { FaChevronCircleRight } from "react-icons/fa";
import { readRemoteFile } from "react-papaparse";
import { toast } from "react-toastify";
import DropZone from "../components/DropZone";
import LoggedInLayout from "../components/LoggedInLayout";
import PageLoader from "../components/PageLoader";
import ToastMsg from "../components/ToastMsg";
import config from "../config";
//import { MdFileDownload } from "react-icons/md";
import { Constants } from "../libs/Constants";
import { create, delObj, getList } from "../libs/dbFunctions";
import { useFormFields } from "../libs/hooksLib";
import { convertDate } from "../libs/utils";
import "./ChangeCompany.css";
import "./ImportData.scss";

const columnMapper = {
  empid: { text: "Emp Id" },
  PeriodStartDate: { text: "Period Start Date" },
  ContributionAmount: { text: "Contribution Amount" },
  PurchasePrice: { text: "Purchase Price" },
  IssueDate: { text: "Issue Date" },
  ModificationDate: { text: "Modification Date" },
  EmployeeStartDate: { text: "Employee Start Date" },
  Subsidary: { text: "Subsidiary" },
  Firstname: { text: "First Name" },
  Lastname: { text: "Last Name" },
  Email: { headerClasses: "text-break text-capitalize width10" },
  email: { headerClasses: "text-break text-capitalize width10" },
  message: { headerClasses: "text-break text-capitalize width10" },
};

const configObj = config.getConfigObject();

export default function ImportData(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [displayList, setDisplayList] = useState([]);
  const [showUpload, setShowUpload] = useState(false);
  const [fields, handleFieldChange] = useFormFields({
    showOnlyErrors: false,
  });

  const [hrUploading, setHrUploading] = useState(false);
  const [contUploading, setContUploading] = useState(false);
  const [companyUploading, setCompanyUploading] = useState(false);
  const columns = [
    {
      dataField: "name",
      text: "File Name",
      formatter: (cell) => {
        return cell;
      },
    },
    {
      dataField: "status",
      text: "Status",
      classes: "text-capitalize",
      formatter: (cell, row) => {
        if (cell === "fail") {
          return (
            <div className="text-danger">
              <OverlayTrigger
                placement="right"
                overlay={
                  <Tooltip style={{ zIndex: 9999999999 }}>
                    {`${row.recordCounts?.failed} of ${row.recordCounts?.total} total rows failed`}
                  </Tooltip>
                }
              >
                <span>
                  Error{" "}
                  <FaChevronCircleRight
                    onClick={() => viewFile(row, true)}
                  ></FaChevronCircleRight>
                </span>
              </OverlayTrigger>
            </div>
          );
        }
        return cell;
      },
    },
    {
      dataField: "type",
      text: "Type",
      classes: "text-capitalize",
      formatter: (cell) => {
        if (cell === "hr") {
          return "HR";
        }
        return cell;
      },
    },
    {
      dataField: "dateOfUpload",
      text: "Upload Date",
    },
    {
      dataField: "fileURL",
      text: "",
      classes: "d-flex justify-content-center",
      formatter: (cell, row, rowIndex) => {
        if (row.status && (row.status === "fail" || row.status === "success")) {
          return (
            <div className="d-flex">
              <a
                onClick={() => viewFile(row)}
                className="secondary font-weight-normal cursor-pointer"
              >
                {" "}
                View{" "}
              </a>{" "}
              {rowIndex === 0 && (
                <a
                  value={row.sort_key}
                  onClick={() => showConfirm(row)}
                  className="danger ps-2 cursor-pointer"
                >
                  Delete
                </a>
              )}
            </div>
          );
        }
        return <></>;
      },
    },
  ];

  useEffect(() => {
    setIsLoading(true);
    onLoad();
  }, [props.isAuthenticated, props.userObj, props.location]);

  useEffect(() => {
    filterRows();
  }, [fields.showOnlyErrors]);

  function filterRows() {
    if (displayList && displayList.length > 0 && fields.showOnlyErrors) {
      return displayList.filter((d) => d.status === "fail");
    }
    return displayList;
  }

  async function viewFile(row, onlyErrors = false) {
    setIsLoading(true);
    readRemoteFile(row.fileURL, {
      error: () => {
        setIsLoading(false);
        toast.error("Unable to preview file");
      },
      complete: (results) => {
        setIsLoading(false);
        if (results && results.data && results.data.length > 0) {
          let csvColumns = [
            {
              dataField: "id",
              text: "Id",
              headerClasses: "text-break",
              hidden: true,
            },
          ];
          let statusIndex = -1;
          for (let index in results.data[0]) {
            if (results.data[0][index].toLowerCase() === "status") {
              statusIndex = index;
            }

            let col = {
              dataField: index,
              text: results.data[0][index],
              headerClasses: "text-break text-capitalize width5",
            };
            if (col.text in columnMapper) {
              col = Object.assign({ ...col }, columnMapper[col.text]);
            }
            csvColumns.push(col);
          }
          if (!onlyErrors) {
            results.data = results.data.splice(1);
            let index = 0;
            for (let r of results.data) {
              r.id = index++;
            }
          }

          if (onlyErrors && statusIndex > -1) {
            results.data = results.data.filter(
              (d) => d[statusIndex] !== "success"
            );
          }
          if (onlyErrors) {
            let csvContent = convertToCSV(results.data);
            results.data = results.data.splice(1);
            Object.assign(row, {
              fileURLOnlyErrors:
                "data:text/csv;charset=utf-8;," + encodeURI(csvContent),
            });
            Object.assign(row, {
              fileNameForOnlyError: {
                download: `${row.sort_key.split("|")[1]}_errorOutput.csv`,
              },
            });
          }
          confirmAlert({
            customUI: ({ onClose }) => {
              return (
                <div className="container react-overlay-csv">
                  <BootstrapTable
                    bootstrap4={true}
                    id="id"
                    wrapperClasses="table-fixed-height"
                    classes="table-taabl table-document"
                    keyField="dateOfUpload"
                    bordered={false}
                    data={results.data}
                    noDataIndication={() => <div>No data found</div>}
                    columns={csvColumns}
                  />
                  <div className="d-flex justify-content-center pt-3">
                    <Button
                      href={onlyErrors ? row.fileURLOnlyErrors : row.fileURL}
                      {...row.fileNameForOnlyError}
                      variant="primary"
                    >
                      Download
                    </Button>
                    <Button variant="cancel" onClick={onClose}>
                      Close
                    </Button>
                  </div>
                </div>
              );
            },
          });
        }
      },
    });
  }
  async function handleDeleteRow(row) {
    setIsLoading(true);
    if (row && row.type === "hr") {
      alert(
        "You can re-import data with updated fields or contact Taabl admin at no-reply@taabl.co"
      );
      return;
    }
    if (row && row.type === "company") {
      alert(
        "You can contact Taabl admin at no-reply@taabl.co for deleting Company."
      );
      return;
    }
    let details = row.sort_key.split("|");
    let importId = details[1];
    let companyId = row.object_id.split("|")[1];
    let params = { importId: importId };
    try {
      await delObj(Constants.dbTypes.IMPORTS, null, companyId, params);
      toast.success("Delete Submitted.");
      let list = displayList;
      list.shift();
      setDisplayList(list);
    } catch (e) {
      if (e.response && e.response.data && e.response.data.error) {
        toast.error(e.response.data.error);
      } else {
        toast.error(e);
      }
    }
    setIsLoading(false);
  }
  async function onLoad() {
    let id = {
      companyId: props.activeCompany.id,
      userId: props.userObj.id,
    };
    try {
      let displayItems = await getList(
        Constants.dbTypes.IMPORTS,
        props.activeCompany,
        id
      );
      if (displayItems && displayItems.length > 0) {
        displayItems = displayItems.map((item, index) => {
          item.dateOfUpload = convertDate(
            item.uploadedAt,
            Constants.DATEFORMAT.MMDDYYYYHH,
            true
          );
          item.fileURL = item.key;
          item.key = index;
          return item;
        });
        setDisplayList(displayItems);
      }
    } catch (e) {
      toast.error(e);
    }
    setIsLoading(false);
  }
  function convertToCSV(objArray) {
    let arr = objArray;
    let csvContent = arr.reduce((st, next) => {
      st +=
        `${Object.values(next)
          .map((value) => `"${value}"`)
          .join(",")}` + "\r\n";
      return st;
    }, "");
    return csvContent;
  }
  async function handleFileSubmit(files, type) {
    // user not allowed to import HR and Contribution files to TaablAdmin company
    if (
      props.activeCompany.id === Constants.TaablAdminCompany &&
      type !== "company"
    ) {
      toast.error("Not allowed to Import Files to TaablAdmin Company");
    } else {
      let file = null;
      if (files && files.length > 0) {
        file = files[0];
      }
      // Check if CSV file
      if (file && file.name.toLowerCase().includes(".csv")) {
        // Call API to get signed URL
        if (type === "company") {
          setCompanyUploading(true);
        } else {
          if (type === "hr") {
            setHrUploading(true);
          } else {
            setContUploading(true);
          }
        }
        try {
          let response = await create(Constants.dbTypes.IMPORTS, {
            type: type,
            name: file.name,
            fileType: file.type,
            companyId: props.activeCompany.id,
          });
          if (response && response.url) {
            // Upload file to s3
            const options = {
              params: {
                Key: response.key,
                ContentType: file.type,
              },
              headers: {
                "Content-Type": file.type,
              },
            };
            try {
              await axios.put(response.url, file, options);
              setHrUploading(false);
              setContUploading(false);
              setCompanyUploading(false);
              toast(
                <ToastMsg message="File Uploaded.  You will be notified by email once import completes" />,
                {
                  className: "toast-primary",
                }
              );
              onLoad();
            } catch (err) {
              console.log(err);
              toast.error(
                "Unable to upload file. Please contract your administrator"
              );
            }
          }
          setIsLoading(false);
        } catch (e) {
          if (e.response && e.response.data && e.response.data.error) {
            toast.error(e.response.data.error);
          } else {
            toast.error(e);
          }
          setHrUploading(false);
          setContUploading(false);
          setCompanyUploading(false);
          setIsLoading(false);
          setError(null);
        }
      } else {
        setError("Invalid file. Only CSV is allowed");
      }
    }
  }

  function showConfirm(row) {
    confirmAlert({
      message:
        "Deleting this import will delete all the data changes done as part of this import. This action cannot be undone. Are you sure you want to delete this import?",
      buttons: [
        {
          label: "Yes",
          onClick: () => handleDeleteRow(row),
        },
        {
          label: "No",
          className: "btn-cancel",
        },
      ],
    });
  }

  async function handleDelete(type) {
    setIsLoading(true);
    let params = { type: Constants.dbTypes.IMPORTS };
    try {
      await delObj(
        Constants.dbTypes.IMPORTS,
        type,
        props.activeCompany.id,
        params
      );
      toast.success(
        "Delete started. We will notify you over email once it finishes."
      );
      if (displayList && displayList.length > 0) {
        setDisplayList(
          displayList.filter((d) => d.type !== ImportTypes.CONTRIBUTION)
        );
      }
    } catch (e) {
      if (e.response && e.response.data && e.response.data.error) {
        toast.error(e.response.data.error);
      } else {
        toast.error(e);
      }
    }
    setIsLoading(false);
  }

  function renderShowErrors() {
    return (
      <div className="d-flex justify-content-between align-items-center pb-4">
        <Form className="text-center">
          <Form.Group
            controlId="showOnlyErrors"
            size="md"
            className={`form-group`}
          >
            <Form.Check
              type="checkbox"
              name="terms"
              id="showOnlyErrors"
              className="tbl-checkbox"
            >
              <Form.Check.Input type="checkbox" onChange={handleFieldChange} />
              <Form.Check.Label className="font-secondary display-5">
                Show only errors
              </Form.Check.Label>
            </Form.Check>
          </Form.Group>
        </Form>
        <Button variant="secondary" onClick={() => setShowUpload(true)}>
          Upload Document
        </Button>
      </div>
    );
  }

  function renderUploadDocument() {
    return (
      <div className="dsp-entr-box">
        <div className="float-right">
          <a
            className="secondary font-text-normal cursor-pointer"
            onClick={() => setShowUpload(false)}
          >
            Close
          </a>
        </div>
        <div className="d-flex justify-content-center drag-drop-card">
          {props.userObj?.permission ===
            Constants.PermissionLevel.TAABL_ADMIN &&
            props.activeCompany?.id === Constants.TaablAdminCompany && (
              <div className="width18">
                <h5>Import Company data</h5>
                <div className="mb7">
                  Import to accurately identify each company and its ESPP
                  details.
                </div>
                <Card>
                  {" "}
                  <DropZone
                    onSubmit={(files) => handleFileSubmit(files, "company")}
                    id="company"
                    uploading={companyUploading}
                  />
                </Card>
                <div className="d-flex error-div justify-content-between">
                  <div>
                    <a
                      className="secondary"
                      href={`${configObj.contentBaseUrl}/company_sample.csv`}
                    >
                      {" "}
                      View Sample
                    </a>
                  </div>
                  {error && <div className="error-msg">{error}</div>}
                </div>
              </div>
            )}
          <div className="width18">
            <h5>Import HR data</h5>
            <div className="mb-2">
              Import to accurately identify each company employee and account
              for their benefits participation.
            </div>
            <Card>
              <DropZone
                onSubmit={(files) => handleFileSubmit(files, "hr")}
                id="hr"
                uploading={hrUploading}
              />
            </Card>
            <div className="d-flex error-div justify-content-between">
              <div>
                <a
                  className="secondary"
                  href={`${configObj.contentBaseUrl}/hr_sample.csv`}
                >
                  {" "}
                  View Sample
                </a>
              </div>
              {error && <div className="error-msg">{error}</div>}
            </div>
          </div>
          <div className="width16">
            <h5>Import Contribution data</h5>
            <div className="mb7">
              Import to accurately account and audit each employee contribution
              election.
            </div>
            <Card>
              {" "}
              <DropZone
                id="contribution"
                onSubmit={(files) => handleFileSubmit(files, "contribution")}
                uploading={contUploading}
              />
            </Card>
            <div className="d-flex error-div justify-content-between">
              <div>
                <a
                  className="secondary"
                  href={`${configObj.contentBaseUrl}/contribution_sample.csv`}
                >
                  {" "}
                  View Sample
                </a>
              </div>
              {error && <div className="error-msg">{error}</div>}
            </div>
          </div>
        </div>
      </div>
    );
  }

  function renderRecentImport() {
    return (
      <PageLoader isActive={isLoading}>
        <div className="mt-3">
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="mb-2 mt-3">Recent Imports</h5>
            {props.userObj.permission >=
              Constants.PermissionLevel.TAABL_ADMIN && (
              <a
                className="secondary cursor-pointer"
                onClick={() =>
                  confirmAlert({
                    message:
                      "This action cannot be undone. Are you sure you want to delete all contributions?",
                    buttons: [
                      {
                        label: "Yes",
                        onClick: () => handleDelete("contribution"),
                      },
                      {
                        label: "No",
                        className: "btn-cancel",
                      },
                    ],
                  })
                }
              >
                Delete all contributions
              </a>
            )}
          </div>
          <BootstrapTable
            bootstrap4={true}
            id="sort_key"
            wrapperClasses="table-fixed-height"
            classes="table-taabl table-document"
            keyField="key"
            bordered={false}
            data={filterRows()}
            noDataIndication={() => <div>No data found</div>}
            columns={columns}
          />
        </div>
      </PageLoader>
    );
  }

  return (
    <LoggedInLayout title="Documents">
      {renderShowErrors()}
      {showUpload && renderUploadDocument()}
      {renderRecentImport()}
    </LoggedInLayout>
  );
}
